import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';
import { ITokenResponse } from '../authentication/models/token-response';
import { IAccountChat } from './account-chat';
import { ChatDataService } from './chat-data.service';
import { NgxZendeskWebwidgetService } from './zendesk-webwidget/zendesk-webwidget.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(private readonly ngxZendeskWebwidgetService: NgxZendeskWebwidgetService,
              private readonly chatDataService: ChatDataService) { }

  public login(tokenResponse: ITokenResponse): void {
    if (tokenResponse.Roles.includes("Teacher")) {
      this.ngxZendeskWebwidgetService.zE("webWidget", "prefill", { 
        name: { 
          value: tokenResponse.Username,
          readOnly: true
        }
      });

      this.chatDataService.getChatInfo()
      .pipe(
        tap((account: IAccountChat) => this.addUserInfo(account),
        untilDestroyed(this)
      ))
      .subscribe()
    }
  }

  public view(): void {
    this.ngxZendeskWebwidgetService.zE('webWidget', 'show');
    this.ngxZendeskWebwidgetService.zE('webWidget', 'open');
  }

  private addUserInfo(account: IAccountChat): void {
    this.ngxZendeskWebwidgetService.zE("webWidget", "prefill", {
      email: {
        value: account.Email,
        readOnly: true 
      },
      phone: {
        value: account.PhoneNumber,
        readOnly: true
      }
    });

    this.ngxZendeskWebwidgetService.zE('webWidget', 'updateSettings', {
      webWidget: {
        chat: {
          tags: ["School: " + account.SchoolName, "Board: " + account.BoardName]
        }
      }
    });
  }

  public logOut(): void {
    if (this.ngxZendeskWebwidgetService.isInitialized) {
      this.ngxZendeskWebwidgetService.zE("webWidget", "logout");
      this.ngxZendeskWebwidgetService.zE("webWidget", "hide");
    }
  }
}
